import { render, staticRenderFns } from "./TagBoard.vue?vue&type=template&id=24fe2889&scoped=true"
import script from "./TagBoard.vue?vue&type=script&lang=js"
export * from "./TagBoard.vue?vue&type=script&lang=js"
import style0 from "./TagBoard.vue?vue&type=style&index=0&id=24fe2889&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fe2889",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24fe2889')) {
      api.createRecord('24fe2889', component.options)
    } else {
      api.reload('24fe2889', component.options)
    }
    module.hot.accept("./TagBoard.vue?vue&type=template&id=24fe2889&scoped=true", function () {
      api.rerender('24fe2889', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pm/tag/TagBoard.vue"
export default component.exports